export default {
  design: 'design',
  layout: 'layout',
};
